#!/usr/bin/env node

import { Command } from "commander";
import { doctorCommand } from "./commands/doctor.js";
import { infoCommand } from "./commands/info.js";
import { explainCommand } from "./commands/explain.js";
import { repairCommand } from "./commands/repair.js";
import { syncCommand } from "./commands/sync.js";
import { installCommand } from "./commands/install.js";
import { analyzeCommand } from "./commands/analyze.js";
import { prebuildCommand } from "./commands/prebuild.js";
import { upgradeCheckCommand } from "./commands/upgradeCheck.js";
import { migrateCommand } from "./commands/migrate.js";
import { graphCommand } from "./commands/graph.js";
import { impactCommand } from "./commands/impact.js";
import { snapshotCommand } from "./commands/snapshot.js";
import { auditCommand } from "./commands/audit.js";
import { buildCommand } from "./commands/build.js";
import { runCommandObj } from "./commands/run.js";

const program = new Command();

program
  .name("kyro")
  .description("React Native environment and project health checker")
  .version("0.0.4-alpha-c2");

program.addCommand(doctorCommand);
program.addCommand(infoCommand);
program.addCommand(explainCommand);
program.addCommand(repairCommand);
program.addCommand(syncCommand);
program.addCommand(installCommand);
program.addCommand(analyzeCommand);
program.addCommand(prebuildCommand);
program.addCommand(upgradeCheckCommand);
program.addCommand(migrateCommand);
program.addCommand(graphCommand);
program.addCommand(impactCommand);
program.addCommand(snapshotCommand);
program.addCommand(auditCommand);
program.addCommand(buildCommand);
program.addCommand(runCommandObj);

program.parse();